import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { paths } from '../../../../routing/path';

export const EcosystemHomepageMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-display2"
        label="Ecosystem Homepage"
        to={paths.account.userHome}
        flagCode={NotificationFlagsCategories.AnnouncementsCode}
        trackingAction="Home"
        gtmCategory="Home"
    />
);
